import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM8 17V15H16V17H8ZM12 14.4142L8.58579 11L10 9.58579L11 10.5858V7H13V10.5858L14 9.58579L15.4142 11L12 14.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowDown;
